<template>
  <div id="gisheader" class="head">
    <!-- nav -->
    <b-navbar class="bg-green" toggleable="xl" type="dark">
      <b-navbar-brand href="/"
        ><img
          src="imgs/logo.png"
          class="logo img-fluid"
          alt=""
        />嘉義縣農情資訊平台
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item href="#/GIS">農情圖資</b-nav-item>
          <template v-if="showmanage.accountshow">
            <b-nav-item-dropdown text="農情資訊">
              <b-dropdown-item href="#/normaldashboard/crop"
                >農業資訊</b-dropdown-item
              >
              <b-dropdown-item href="#/normaldashboard/fishcatch"
                >漁業資訊</b-dropdown-item
              >
              <b-dropdown-item href="#/normaldashboard/animal"
                >畜產資訊</b-dropdown-item
              >
              <b-dropdown-item href="#/databuildforpestsdiseases"
                >病蟲害資訊</b-dropdown-item
              >
            </b-nav-item-dropdown>
          </template>
          <template v-else>
            <b-nav-item href="#/normaldashboard/crop">農業資訊</b-nav-item>
            <b-nav-item href="#/normaldashboard/fishcatch">漁業資訊</b-nav-item>
            <b-nav-item href="#/normaldashboard/animal">畜產資訊</b-nav-item>
            <b-nav-item href="#/databuildforpestsdiseases">病蟲害資訊</b-nav-item>
          </template>
          <b-nav-item-dropdown
            v-if="
              showmanage.dashboard.farmshow ||
                showmanage.dashboard.fishshow ||
                showmanage.dashboard.animalshow ||
                showmanage.dashboard.cropshow
            "
            text="產銷儀錶板"
            right
          >
            <b-dropdown-item
              v-if="showmanage.dashboard.farmshow"
              href="#/maindashboardforcrop"
              >農產品交易價量分析</b-dropdown-item
            >
            <b-dropdown-item
              v-if="showmanage.dashboard.fishshow"
              href="#/dashboardforfish"
              >漁產品交易價量分析</b-dropdown-item
            >
            <b-dropdown-item
              v-if="showmanage.dashboard.animalshow"
              href="#/dashboardForanimal"
              >畜產品交易價量分析</b-dropdown-item
            >
            <b-dropdown-item
              v-if="showmanage.dashboard.cropshow"
              href="#/dashboardforricefarm"
              >稻作交易價量分析</b-dropdown-item
            >
          </b-nav-item-dropdown>
          <b-nav-item-dropdown
            v-if="
              showmanage.databuild.farmshow ||
                showmanage.databuild.fishshow ||
                showmanage.databuild.animalshow ||
                showmanage.databuild.cropshow ||
                showmanage.databuild.pentshow
            "
            text="資料管理"
            right
          >
            <!-- <b-dropdown-item href="#">交易行情(測試)</b-dropdown-item>
                <b-dropdown-item href="#">自有農情(測試)</b-dropdown-item>
                <b-dropdown-item href="#">預警設定(測試)</b-dropdown-item> -->
            <b-dropdown-item
              v-if="showmanage.databuild.farmshow"
              href="#/databuild"
              >農產品價格維護</b-dropdown-item
            >            
            <b-dropdown-item
              v-if="showmanage.databuild.farmsearchshow"
              href="#/databuildforfarmsearch"
              >農情調查資料維護</b-dropdown-item
            >
            <b-dropdown-item
              v-if="showmanage.databuild.fishshow"
              href="#/databuildforfishcatch"
              >漁產品價格維護</b-dropdown-item
            >
            <b-dropdown-item
              v-if="showmanage.databuild.animalshow"
              href="#/databuildforanimal"
              >畜產品價格維護</b-dropdown-item
            >
            <b-dropdown-item
              v-if="showmanage.databuild.cropshow"
              href="#/databuildforricefarm"
              >稻作價格維護</b-dropdown-item
            >
            <b-dropdown-item
              v-if="showmanage.databuild.pentshow"
              href="#/databuildforinsectpests"
              >病蟲害資料維護</b-dropdown-item
            >
            <!-- <b-dropdown-item>病蟲害資料維護(開發中)</b-dropdown-item> -->
            <!-- <b-dropdown-item href="#">稻作產品價格維護(測試)</b-dropdown-item> -->
          </b-nav-item-dropdown>
          <b-nav-item v-if="showmanage.iflogin" href="#/OpenInfo"
            >資訊服務</b-nav-item
          >
          <b-nav-item-dropdown
            v-if="showmanage.accountshow"
            text="帳號權限管理"
            right
          >
            <b-dropdown-item href="#/account">帳號管理</b-dropdown-item>
            <b-dropdown-item href="#/authority">群組權限管理</b-dropdown-item>
          </b-nav-item-dropdown>
          <!-- <b-nav-item-dropdown v-if="showmanage.iflogin" text="個人資料" right>
            <b-dropdown-item href="#/changepassword" v-if="!isLine">變更密碼</b-dropdown-item>
            <b-dropdown-item href="#/profile">個人資料維護</b-dropdown-item>
          </b-nav-item-dropdown> -->
          <!-- <b-nav-item href="#/databuildforpestsdiseases">病蟲害資訊</b-nav-item> -->
          <template v-if="showmanage.accountshow">
            <b-nav-item-dropdown
              text="個人化專區"
              right
            >
              <b-dropdown-item href="#/myprefecture">我的專區</b-dropdown-item>
              <b-dropdown-item href="#/myarea">我的漲跌勢</b-dropdown-item>
              <!-- <b-dropdown-item  v-if="!showmanage.manage.manager"  href="#/dashboardCustomize/0">自定義圖表分析</b-dropdown-item> -->
            </b-nav-item-dropdown>
          </template>
          <template v-else>
            <b-nav-item  href="#/myprefecture">我的專區</b-nav-item>
            <b-nav-item  href="#/myarea">我的漲跌勢</b-nav-item>
          </template>
          <b-nav-item  v-if="showmanage.customize.showPart"  href="#/dashboardCustomize/0">自定義圖表分析</b-nav-item>
          <b-nav-item  v-if="showmanage.customize.showAll"  href="#/dashboardCustomize/1">自定義圖表分析</b-nav-item>
          <b-nav-item-dropdown
            v-if="showmanage.manage.cropShow || showmanage.manage.fishShow || showmanage.manage.animalsShow"
            text="主管業務專區"
            right
          >
            <b-dropdown-item v-if="showmanage.manage.cropShow" href="#/SupervisorArea">農業專區</b-dropdown-item>
            <b-dropdown-item v-if="showmanage.manage.fishShow" href="#/SupervisorFishArea">漁業專區</b-dropdown-item>
            <b-dropdown-item v-if="showmanage.manage.animalsShow" href="#/SupervisorAnimalArea">畜產專區</b-dropdown-item>
            <!-- <b-dropdown-item v-if="showmanage.manage.manager" href="#/dashboardCustomize/1">自定義圖表分析</b-dropdown-item> -->
          </b-nav-item-dropdown>
          <!-- <b-nav-item v-if="showmanage.accountshow"  href="#/SupervisorArea">主管專區</b-nav-item> -->
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item
            v-if="showmanage.iflogin && cangetGeft"
            href="#/getgift"
            ><svg fill="#ffffff" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25px" height="25px" viewBox="0 0 20.76 20.76" xml:space="preserve" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path d="M1.88,18.76c0,1.101,0.9,2,2,2h4.5V10.281h-6.5V18.76z"></path> <path d="M12.38,20.76h4.5c1.1,0,2-0.899,2-2v-8.479h-6.5V20.76z"></path> <path d="M17.255,4.26H14c0.103-0.012,0.2-0.024,0.307-0.036c2.113-0.237,3.798-1.001,3.798-2.971c0-0.657-0.949-1.532-2.567-1.167 c-1.607,0.363-3.683,2.152-4.256,3.078c-0.147-0.354-0.495-0.6-0.901-0.6c-0.405,0-0.753,0.246-0.9,0.598 C8.906,2.238,6.83,0.448,5.223,0.086c-1.618-0.365-2.568,0.51-2.568,1.167c0,1.97,1.685,2.733,3.798,2.971 C6.559,4.236,6.658,4.248,6.76,4.26H3.506c-1.169,0-2.126,0.956-2.126,2.125v2.896h7V4.219h1.5V20.76h1V4.219h1.5v5.062h7V6.385 C19.38,5.216,18.423,4.26,17.255,4.26z M6.73,3.906c-1.565-0.176-2.813-0.74-2.813-2.199c0-0.487,0.704-1.135,1.902-0.864 c1.392,0.314,3.268,2.08,3.268,2.567C9.088,3.895,8.148,4.066,6.73,3.906z M11.673,3.409c0-0.487,1.876-2.253,3.268-2.567 c1.197-0.271,1.901,0.377,1.901,0.864c0,1.459-1.247,2.023-2.813,2.199C12.612,4.066,11.673,3.895,11.673,3.409z"></path> </g> </g> </g></svg>
            </b-nav-item>
          <b-nav-item
            v-if="showmanage.iflogin && isLine"
            style="margin-right: 0.5rem;"
            href="#/accountbinding"
            >綁定帳號</b-nav-item
          >
          <!-- <b-nav-item
            v-if="showmanage.iflogin"
            style="margin-right: 0.5rem;display: flex;flex-flow: row wrap;align-items: center;"
            href="#/subscription"
            >訂閱</b-nav-item
          > -->
          <b-nav-item v-if="documentlink != null" :href="documentlink"
            >操作手冊</b-nav-item
          >
          <b-nav-item v-if="!Sended">
            <Questionnair />
          </b-nav-item>
          <b-nav-form>
            <!-- <label class="login-name">{{ accountid }},你好</label> -->
            <b-nav-item-dropdown v-if="showmanage.iflogin" :text="accountid+',你好'" right>
              <b-dropdown-item href="#/changepassword" v-if="!isLine">變更密碼</b-dropdown-item>
              <b-dropdown-item href="#/profile">個人資料維護</b-dropdown-item>
            </b-nav-item-dropdown>
            <button
              v-if="!showmanage.iflogin"
              type="button"
              class="btn btn-success"
              @click="$router.push('/login')"
            >
              登入
            </button>
            <button
              v-else
              type="button"
              class="btn btn-success"
              @click="userSignOut"
            >
              登出
            </button>
          </b-nav-form>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>
<script>
import Questionnair from '@/components/Questionnair.vue'
export default {
  name: "Header",
  components : {
    Questionnair
  },
  data() {
    return {
      Sended: false,
      weather: {
        MaxT: null,
        MinT: null,
        Wx: null,
        PoP: null,
      },
      showmanage: {
        accountshow: false,
        iflogin: false,
        dashboard: {
          farmshow: false,
          fishshow: false,
          animalshow: false,
          cropshow: false,
        },
        databuild: {
          farmshow: false,
          fishshow: false,
          animalshow: false,
          cropshow: false,
          pentshow: false,
          farmsearchshow:true
        },
        manage:{
          //manager: false,
          cropShow: false,
          fishShow: false,
          animalsShow: false,
          //customize: false
        },
        customize:{
          showAll: false,
          showPart: false,
        }
      },
      documentlink: null,
      GROUPMyList: [],
      month: null,
      day: null,
      hour: "day",
      accountid: "訪客",
      apiGetWeather: (data) =>
        this.userRequest.post("API/Default/GetWeather", data),
      apiGetSystemManualDownload: (data) =>
        this.userRequest.post("/API/Default/SystemManualDownload", data),
    };
  },
  // components: {

  // },
  created(){
    if(sessionStorage.getItem("GoogleFrom")){
        this.Sended = true;
    }
  },
  mounted() {
    //console.log("header mounted is called");
    this.FunctionToken(this.getWeather, {});
    var d = new Date();
    this.month = d.getMonth() + 1;
    this.day = d.getDate();
    let hours = d.getHours();
    if (hours >= 18) this.hour = "night";
    this.checkLogin();
    this.checkUserName();
  },
  methods: {
    changePage(value) {
      this.$router.push({ name: value });
    },
    getWeather(data) {
      this.apiGetWeather(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            this.weather.MaxT = jsonData.MaxT;
            this.weather.MinT = jsonData.MinT;
            this.weather.Wx = this.padLeft(jsonData.Wx, 2);
            this.weather.PoP = jsonData.PoP;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    getDocumentLink(data) {
      this.apiGetSystemManualDownload(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.documentlink = null;
            let jsonData = JSON.parse(json.Data);
            this.documentlink = jsonData;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    padLeft(str, lenght) {
      str = str.toString();
      if (str.length >= lenght) return str;
      else return this.padLeft("0" + str, lenght);
    },
    checkUserName() {
      if (sessionStorage.getItem("username")) {
        this.accountid = sessionStorage.getItem("username");
        this.showmanage.iflogin = true;
      } else {
        this.accountid = "訪客";
        this.showmanage.iflogin = false;
      }
    },
    checkLogin() {
      let TokenID = sessionStorage.getItem("TokenID");
      if (TokenID) {
        // this.accountshow = true;
        this.FunctionToken(this.getDocumentLink, {});
        this.checkPermission();
      } else {
        this.showmanage.iflogin = false;
        this.showmanage.accountshow = false;
        // this.showmanage.datamanagement.databuild.show = false
      }
    },
    async checkPermission() {
      await this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000001",
        fun: this.checkByPJID,
      });
    },
    permisecondcheck() {
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000002",
        fun: this.checkByPJIDdashboardfarmshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000003",
        fun: this.checkByPJIDdashboardfishshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000004",
        fun: this.checkByPJIDdashboardanimalshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000005",
        fun: this.checkByPJIDdashboardcropshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000006",
        fun: this.checkByPJIDdatabuildfarmshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000007",
        fun: this.checkByPJIDdatabuildfarmshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000008",
        fun: this.checkByPJIDdatabuildfarmshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000009",
        fun: this.checkByPJIDdatabuildfarmshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000010",
        fun: this.checkByPJIDdatabuildfishshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000011",
        fun: this.checkByPJIDdatabuildfishshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000012",
        fun: this.checkByPJIDdatabuildfishshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000013",
        fun: this.checkByPJIDdatabuildfishshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000014",
        fun: this.checkByPJIDdatabuildanimalshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000015",
        fun: this.checkByPJIDdatabuildanimalshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000016",
        fun: this.checkByPJIDdatabuildanimalshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000017",
        fun: this.checkByPJIDdatabuildanimalshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000018",
        fun: this.checkByPJIDdatabuildcropshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000019",
        fun: this.checkByPJIDdatabuildcropshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000020",
        fun: this.checkByPJIDdatabuildcropshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000021",
        fun: this.checkByPJIDdatabuildcropshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000022",
        fun: this.checkByPJIDdatabuildpentshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000023",
        fun: this.checkByPJIDdatabuildpentshow,
      });
      // this.FunctionToken(this.Authority, {
      //   PJ_ID: "PJ000000000024",
      //   fun: this.checkByPJIDdatabuildpentshow,
      // });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000025",
        fun: this.checkByPJIDdatabuildpentshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000032",
        fun: this.checkByPJIDmanagershow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000034",
        fun: this.checkByPJIDashboardCustomize1,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000035",
        fun: this.checkByPJIDashboardCustomize2,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000037",
        fun: this.checkByPJIDmanagerfishshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000039",
        fun: this.checkByPJIDmanageranimalshow,
      });
    },
    checkByPJID(value) {
      if (!value) {
        this.showmanage.accountshow = false;
      } else {
        this.showmanage.accountshow = true;
      }
      this.permisecondcheck();
    },
    checkByPJIDdashboardfarmshow(value) {
      if (value) this.showmanage.dashboard.farmshow = true;
    },
    checkByPJIDdashboardfishshow(value) {
      if (value) this.showmanage.dashboard.fishshow = true;
    },
    checkByPJIDdashboardanimalshow(value) {
      if (value) this.showmanage.dashboard.animalshow = true;
    },
    checkByPJIDdashboardcropshow(value) {
      if (value) this.showmanage.dashboard.cropshow = true;
    },
    checkByPJIDdatabuildfarmshow(value) {
      if (value) this.showmanage.databuild.farmshow = true;
    },
    checkByPJIDdatabuildfishshow(value) {
      if (value) this.showmanage.databuild.fishshow = true;
    },
    checkByPJIDdatabuildanimalshow(value) {
      if (value) this.showmanage.databuild.animalshow = true;
    },
    checkByPJIDdatabuildcropshow(value) {
      if (value) this.showmanage.databuild.cropshow = true;
    },
    checkByPJIDdatabuildpentshow(value) {
      if (value) this.showmanage.databuild.pentshow = true;
    },
    checkByPJIDmanagershow(value) {
      if (value) this.showmanage.manage.cropShow = true;
    },
    checkByPJIDmanagerfishshow(value) {
      if (value) this.showmanage.manage.fishShow = true;
    },
    checkByPJIDmanageranimalshow(value) {
      if (value) this.showmanage.manage.animalsShow = true;
    },
    // checkByPJIDcustomizeshow(value) {
    //   if (value) this.showmanage.manage.customize = true;
    // },
    checkByPJIDashboardCustomize1(value) {
      if (value) this.showmanage.customize.showAll = true;
    },
    checkByPJIDashboardCustomize2(value) {
      if (value) this.showmanage.customize.showPart = true;
    },
    userSignOut() {
      sessionStorage.removeItem("TokenID");
      sessionStorage.removeItem("username");
      sessionStorage.removeItem("isLine");
      sessionStorage.removeItem("lineUserid");
      sessionStorage.removeItem("getGift");
      sessionStorage.removeItem("GoogleFrom");
      // this.GROUPMyList = [];
      // this.checkLogin()
      this.$parent.refresh();
      this.$router.push({ path: "/login" });
    },
    goDashboardCustomize(value){
      this.$router.push({ name: "dashboardCustomize", params: { type: value } });
    }
  },
};
</script>
<style lang="scss">
.logo {
  height: 48px;
}
@media (max-width: 400px) {
  .navbar-brand {
    font-size: 0.9rem !important;
  }
}
</style>
